<template>
  <div>
    <iframe v-if="canViewPDF" frameborder="0" :src="pdfsrc" :width="width" :height="height"></iframe>
    <p class="font-weight-medium" v-if="operationUuidMsg">El identificador de la operación es un campo obligatorio para poder ver el acta de la operación.</p>
    <p id="snackbar-success"></p>
    <p id="snackbar-error"></p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    endPoint: String,
    operationUuid: String,
    token: String,
    width: Number,
    height: Number,
    status: {
      type: Number,
      default: 0
    },
    response: {
      type: String,
      default: "Visualice un documento"
    },
    loading: Boolean,
    snackBar: Boolean,
    successMsg: String,
    errorMsg: String
  },
  data() {
    return {
      pdfsrc: "",
      canViewPDF: true,
      operationUuidMsg: false
    };
  },
  mounted() {
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    if (this.operationUuidMsg === true) {
      this.canViewPDF = false;
    } else {
      this.getDocument();
    }
  },
  methods: {
    getDocument() {
      axios.defaults.headers.common.Authorization = this.token;
      if (this.loading) {
        this.showLoading();
      }
      this.EventBus.$emit("notifyViewActaPDF", "showLoading");
      // window.postMessage({ type: 'componentCallback', status: 2, component: 'esign-view-acta-pdf' }, '*');
      axios.get(`${this.endPoint}${this.operationUuid}`).then(
        responseSuccess => {
          if (this.loading) {
            this.hideLoading();
          }
          this.pdfsrc = `data:application/pdf;base64,${responseSuccess.data}`;
          if (this.snackBar) {
            this.$showSnackBar("snackbar-success", this.successMsg);
          }
          this.EventBus.$emit("notifyViewActaPDF", "hideLoading");
          this.EventBus.$emit("successViewActaPDF");
        },
        responseError => {
          if (this.loading) {
            this.hideLoading();
          }
          if (this.snackBar) {
            this.$showSnackBar("snackbar-error", this.errorMsg);
          }
          this.EventBus.$emit("notifyViewActaPDF", "hideLoading");
          this.EventBus.$emit("errorViewActaPDF");
        }
      );
    }
  }
};
</script>

<style>
</style>
